import { render, staticRenderFns } from "./virtualCurrency.vue?vue&type=template&id=0fbacfd1&scoped=true&"
import script from "./virtualCurrency.vue?vue&type=script&lang=js&"
export * from "./virtualCurrency.vue?vue&type=script&lang=js&"
import style0 from "./virtualCurrency.vue?vue&type=style&index=0&id=0fbacfd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbacfd1",
  null
  
)

export default component.exports